import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  formatSubscriptionStatusLabel,
  getSubscriptionStatusDotColor,
  getSubscriptionStatusKey,
} from './subscriptionStatus';

const SubStatusBadge: React.FC<{ status: string }> = ({ status }) => {
  const { t } = useTranslation();
  const dot = getSubscriptionStatusDotColor(status);
  const statusKey = getSubscriptionStatusKey(status);
  const label = statusKey ? t(`status.${statusKey}`) : formatSubscriptionStatusLabel(status);
  return (
    <span
      style={{
        border: '1px solid #E5E5E5',
        backgroundColor: '#F5F5F5',
        borderRadius: 6,
        padding: '2px 8px',
        fontSize: 12,
        display: 'inline-flex',
        alignItems: 'center',
        gap: 5,
      }}
    >
      <span
        style={{
          width: 12,
          height: 12,
          borderRadius: '50%',
          backgroundColor: dot,
          display: 'inline-block',
        }}
      />
      {label}
    </span>
  );
};

export default SubStatusBadge;
